import React from 'react';

// The five competition-workflow statuses and their traffic-light colours,
// matching the IRIS control-panel spec (🔴🟡🔵🟠🟢).
export const CW_STATUS = {
  not_started:      { label: 'Not Started',      color: '#E53935' }, // 🔴
  in_progress:      { label: 'In Progress',      color: '#FBC02D' }, // 🟡
  submitted:        { label: 'Submitted',        color: '#1E88E5' }, // 🔵
  changes_required: { label: 'Changes Required', color: '#FB8C00' }, // 🟠
  approved:         { label: 'Approved',         color: '#43A047' }, // 🟢
};

export const cwMeta = (status) => CW_STATUS[status] || { label: status || '—', color: '#9E9E9E' };

// A coloured dot + label; pass compact to render only the dot (grid cells).
const CompetitionStatus = ({ status, compact = false, title }) => {
  const { label, color } = cwMeta(status);
  return (
    <span
      title={title || label}
      style={{ display: 'inline-flex', alignItems: 'center', gap: 6, whiteSpace: 'nowrap' }}
    >
      <span style={{
        width: 10, height: 10, borderRadius: '50%',
        backgroundColor: color, flexShrink: 0,
        boxShadow: `0 0 0 2px ${color}22`,
      }} />
      {!compact && <span style={{ fontSize: 13, color: 'var(--text-primary, #333)' }}>{label}</span>}
    </span>
  );
};

export default CompetitionStatus;
